/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardResponseObject } from './RewardResponseObject';
import {
    RewardResponseObjectFromJSON,
    RewardResponseObjectFromJSONTyped,
    RewardResponseObjectToJSON,
    RewardResponseObjectToJSONTyped,
} from './RewardResponseObject';

/**
 * 
 * @export
 * @interface ClaimOverwolfRewardResponse
 */
export interface ClaimOverwolfRewardResponse {
    /**
     * 
     * @type {Array<RewardResponseObject>}
     * @memberof ClaimOverwolfRewardResponse
     */
    rewards: Array<RewardResponseObject>;
}

/**
 * Check if a given object implements the ClaimOverwolfRewardResponse interface.
 */
export function instanceOfClaimOverwolfRewardResponse(value: object): value is ClaimOverwolfRewardResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function ClaimOverwolfRewardResponseFromJSON(json: any): ClaimOverwolfRewardResponse {
    return ClaimOverwolfRewardResponseFromJSONTyped(json, false);
}

export function ClaimOverwolfRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimOverwolfRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(RewardResponseObjectFromJSON)),
    };
}

export function ClaimOverwolfRewardResponseToJSON(json: any): ClaimOverwolfRewardResponse {
    return ClaimOverwolfRewardResponseToJSONTyped(json, false);
}

export function ClaimOverwolfRewardResponseToJSONTyped(value?: ClaimOverwolfRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(RewardResponseObjectToJSON)),
    };
}

